export var actionTypePrefix = '@@CommentThread';
export var commentRestoreFlag = 'comment_offset_restoration';
export var commentOffsetParamName = 'comment';
//# sourceMappingURL=constants.js.map